import SimpleModal from "../../../../components/SimpleModal";
import { useDispatch } from "react-redux";
import { useState } from "react";

import { updateLevel } from "../../studentSlice";

export const LevelEditModal = ({
  setIsEditModalOpen,
  editLevelId,
  levelName,
}) => {
  const dispatch = useDispatch();

  const [newLevelName, setNewLevelName] = useState(levelName);

  const handleEditLevelSubmit = async () => {
    try {
      // 여기서 Redux action이나 API 호출로 학급명을 업데이트
      await dispatch(
        updateLevel({ id: editLevelId, levelData: { name: newLevelName } })
      ).unwrap();
      alert("학급명이 변경되었습니다.");
      setIsEditModalOpen(false);
    } catch (err) {
      alert("학급명 변경에 실패했습니다.");
    }
  };

  return (
    <SimpleModal
      title="학급명 변경하기"
      onClose={() => setIsEditModalOpen(false)}
      onSubmit={handleEditLevelSubmit}
      buttonText="변경하기"
    >
      <div style={{ marginBottom: "20px" }}>
        <input
          type="text"
          placeholder="변경할 클래스명을 입력하세요."
          value={newLevelName}
          onChange={(e) => setNewLevelName(e.target.value)}
          style={{
            padding: "8px 12px",
            borderRadius: "5px",
            border: "1px solid #2D2D2D",
            width: "370px",
          }}
        />
      </div>
    </SimpleModal>
  );
};
